import { inject, observer } from "mobx-react";
import { useEffect, useState } from "react";

import './style.scss';

import {
  Card, CheckBox, PermissionForm, TreeFolder
  //@ts-ignore
} from '@microui/react-ui';
import RoleType from "constants/types/role-type";

const AssignPermission = ({ store }: any) => {
  const { channelId, applicationId } = store;
  const [tab, setTab] = useState(0);

  useEffect(() => {
    store.getDataRole(applicationId, channelId);
    store.getDataPermission(applicationId, channelId);
  }, []);

  useEffect(() => {
    if (!store.enableRoleScope) {
      setTab(0);
    }
  }, [store.enableRoleScope]);

  return (
    <Card
      className="h-full flex flex-col"
      headClassName="p-0"
      head={(
        <div className="flex h-full w-full">
          <div className="w-80 h-full pl-4">
            <div className="text-body-1 flex items-center text-center text-gray-300 font-medium h-full">Chọn vai trò</div>
          </div>
          <div className="flex-1 flex pl-4">
            <div className="flex flex-1 text-body-1 text-gray-300 font-medium relative">
              <div className="flex w-full absolute bottom-[-2px] h-full gap-8">
                <div
                  onClick={() => setTab(0)}
                  className={`text-headline-5 text-gray-3 h-full border-b-[3px] border-[transparent] ${tab === 0 && 'text-primary-400 border-b-[3px] border-primary-400'} flex items-center text-center cursor-pointer hover:text-primary-500`}
                >
                  Phân quyền
                </div>

                {
                  store.enableRoleScope &&
                  <div
                    onClick={() => setTab(1)}
                    className={`text-headline-5 text-gray-3 h-full border-b-[3px] border-[transparent] ${tab === 1 && 'text-primary-400 border-b-[3px] border-primary-400'} flex items-center text-center cursor-pointer hover:text-primary-500`}
                  >
                    Phạm vi quyền
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      )}
      bodyClassName="flex-1 flex flex-col overflow-hidden"
    >
      <div className="flex overflow-hidden flex-1">
        <div className="role w-80 border-r">
          <div className="roleLits overflow-y-auto p-2">
            {
              store.roleList.map((role) => (
                <div
                  className={`roleitem flex h-10 items-center gap-3 px-2 rounded-md hover:bg-primary-1000 transition-all`}
                  key={role.id}
                >
                  <CheckBox
                    checked={store.selectedRoleKeys.includes(role.id)}
                    onChange={() => store.selectRole(role)}
                  />
                  <div
                    aria-hidden
                    className={`cursor-pointer w-full`}
                    onClick={() => {
                      store.selectRole(role);
                      setTab(0);
                    }}
                  >
                    {role.name}
                  </div>
                </div>
              ))
            }
          </div>
        </div>

        {!!store.dataPermissions && (
          <div className="perm flex-1 rounded-r-8 overflow-y-auto flex flex-col">
            <div className="permediter flex flex-col pl-4 overflow-hidden flex-1">
              {tab == 0 && (
                <PermissionForm
                  data={store.dataPermissions}
                  onChange={(val) => {
                    store.handleSelectPermission(val);
                  }}
                  selected={store.selectedPermission}
                  styleName="min-height-rule"
                  className="overflow-auto flex-1"
                />
              )}
              {tab == 1 && (
                <TreeFolder
                  selectedKeys={store.roleScope}
                  data={store.dataOrganization}
                  onSelect={(itm) => store.setValue({ roleScope: itm })}
                  mutiple

                />
              )}
            </div>
          </div>
        )}
      </div>
    </Card>
  );
};

export default inject('store')(observer(AssignPermission));